import React from 'react';

// @ts-ignore
import { Button, Icon } from '@polichat/flamboyant';

import CreditIndexNewPoliImg from '../../../../../../assets/images/newIdentity/CreditIndexImg.svg';

import { Container } from './CreditIndex.styles';
import { useGlotaT } from '../../../../../../hooks/useGlotaTranslation';

interface ToggleModalAddCredit {
  (): void;
}

interface FooProp {
  toggleModalAddCredit: ToggleModalAddCredit;
  screenAdmin: boolean;
}

const CreditIndex = (props: FooProp) => {
  const { toggleModalAddCredit, screenAdmin } = props;

  const imageAlt = useGlotaT('spa.credits.index.imageAlt');
  const noCreditsTitle = useGlotaT('spa.credits.index.noCreditsTitle');
  const adminMessage = useGlotaT('spa.credits.index.adminMessage');
  const userMessage = useGlotaT('spa.credits.index.userMessage');
  const addCreditButton = useGlotaT('spa.credits.index.addCreditButton');

  return (
    <>
      <Container>
        <img
          src={CreditIndexNewPoliImg}
          alt={imageAlt}
        />
        <h2>{noCreditsTitle}</h2>

        <p>
          {screenAdmin ? adminMessage : userMessage}
        </p>

        {!screenAdmin && (
          <Button gradient="primary" onClick={toggleModalAddCredit}>
            {addCreditButton}
            <Icon
              icon="poli-icon pi-add-circle-line"
              size={24}
              position={'relative'}
              top={3}
              left={5}
            />
          </Button>
        )}
      </Container>
    </>
  );
};

export default CreditIndex;
